module.exports = __webpack_public_path__ + "img/teeth-47.b981c898.png";